import React from 'react';
import { Spinner, Stack } from '@servicetitan/design-system';
import classNames from 'classnames';
import styles from './document-pdf-viewer.less';
import { TouchscreenPdfViewer } from '../touchscreen-pdf-viewer/touchscreen-pdf-viewer';

interface DocumentPdfViewerProps {
    src: string;
    isLoading: boolean;
    onPdfLoad: () => void;
}

export const DocumentPdfViewer: React.FC<DocumentPdfViewerProps> = (props) => {
    const { src, isLoading, onPdfLoad } = props;

    // give iframe time to render. TODO: use ref and requestIdleCallback from the iframe.
    const onIframeLoad = () => {
        setTimeout(() => {
            onPdfLoad();
        }, 100);
    };

    // Safari's native pdf viewer on tablet is a bad experience, so we want to use TouchscreenPdfViewer
    const isIpad = () => {
        if (navigator.userAgent.includes('iPad')) {
            return true;
        }

        // ios13 userAgent mimics desktop, and currently no apple desktop products have touchscreen
        if (navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints > 0) {
            return true;
        }

        return false;
    };

    if (isIpad()) {
        return <TouchscreenPdfViewer src={src} />;
    }

    return (
        <>
            {isLoading && (
                <Stack justifyContent="center" alignItems="center" className={styles.fullHeight}>
                    <Spinner size="large" />
                </Stack>
            )}
            <iframe
                src={src}
                className={classNames('w-100', styles.fullHeight)}
                onLoad={onIframeLoad}
                style={{ display: isLoading ? 'none' : 'block' }}
            />
        </>
    );
};
